import { defineAsyncComponent } from "vue";
import lodash from "lodash";
import store from "../../../../../../store";
import { conditionFormChecker, putField } from "../../../../../../utils/form";
import i18n from "../../../../../../i18n";
import {
    createFieldDate,
    createFieldInput
} from "../../../../../../components/input/template-builder/template-builder.logic";

const CardBorder = defineAsyncComponent(() => import("../../../../../../components/card/CardBorder"));
const Address = defineAsyncComponent(() => import("../../../../../../components/address/Address"));
const CancelSequestrateProductTable = defineAsyncComponent(() => import("../cancel-sequestrate-product-info/CancelSequestrateProductTable"));
const CancelSequestrateResultInfoForm = defineAsyncComponent(() => import("../cancel-sequestrate-result-info/CancelSequestrateResultInfoForm"));

export const callDepartment = () => store.dispatch("resource/v1/master/department/cacheFindAllWithChildrenType", { type: "main" });

export const createField = ({ props, data, key, isLoading }) => {
    const { menuContext, viewOnly, dataKey } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldDate({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}cancelSequestrateDate`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 10 }, wrapperCol: { xs: 24, md: 14 } }),
                label: () => `${i18n.global.t("model.cancelSequestrate.cancelSequestrateDate")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model?.cancelSequestrateDate,
                            "onUpdate:value": value => {
                                model.cancelSequestrateDate = value;
                            },
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24 }),
            },
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}regulation`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 10 }, wrapperCol: { xs: 24, md: 14 } }),
                label: () => `${i18n.global.t("model.cancelSequestrate.regulation")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model?.regulation,
                            "onUpdate:value": value => {
                                model.regulation = value;
                            },
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24 }),
            },
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}customer`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 10 }, wrapperCol: { xs: 24, md: 14 } }),
                label: () => `${i18n.global.t("model.cancelSequestrate.customer")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model?.customer,
                            "onUpdate:value": value => {
                                model.customer = value;
                            },
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24 }),
            },
            {
                visible: () => true,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 5 }, wrapperCol: { xs: 24, md: 19 } }),
                label: () => `${i18n.global.t("model.cancelSequestrate.addresses")}`,
                inputRender: () => {
                    const locale = [{ name: "Th", suffix: true }];
                    return <Address
                        menuContext={menuContext}
                        viewOnly={viewOnly}
                        dataProp={data}
                        dataKey={`${prefix}addresses.0`}
                        isLoading={isLoading?.value}
                        locale={locale}
                        onUpdateSome={() => {
                            model.isSave = true;
                        }}
                    ></Address>
                }
            },
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}openInspector`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 10 }, wrapperCol: { xs: 24, md: 14 } }),
                label: () => `${i18n.global.t("model.cancelSequestrate.openInspector")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model?.openInspector,
                            "onUpdate:value": value => {
                                model.openInspector = value;
                            },
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24 }),
            },
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refSequestrate.refReleaseProduct.refRelease.refInspection.refInformTemp.approveCode`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 10 }, wrapperCol: { xs: 24, md: 14 } }),
                label: () => `${i18n.global.t("views.request.cancelSequestrateInfo.informApproveCode")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: lodash.get(modelRef, field?.key),
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refSequestrate.refReleaseProduct.refInspectionProduct.refInformProduct.invoiceCode`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 10 }, wrapperCol: { xs: 24, md: 14 } }),
                label: () => `${i18n.global.t("views.request.cancelSequestrateInfo.invoiceCode")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: lodash.get(modelRef, field?.key),
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refSequestrate.refReleaseProduct.refInspectionProduct.refInformProduct.invoiceCode`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 10 }, wrapperCol: { xs: 24, md: 14 } }),
                label: () => `${i18n.global.t("views.request.cancelSequestrateInfo.transportDoc")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: lodash.get(modelRef, field?.key),
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24 }),
            },
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refSequestrate.storageLocationName`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 10 }, wrapperCol: { xs: 24, md: 14 } }),
                label: () => `${i18n.global.t("views.request.cancelSequestrateInfo.storageLocationName")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: lodash.get(modelRef, field?.key),
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24 }),
            },
            {
                visible: () => true,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 5 }, wrapperCol: { xs: 24, md: 19 } }),
                label: () => `${i18n.global.t("model.cancelSequestrate.addresses")}`,
                inputRender: () => {
                    const locale = [{ name: "Th", suffix: true }];
                    const address = lodash.get(modelRef, `${prefix}refSequestrate.addresses.0`);
                    return !address ? <></> : <Address
                        menuContext={menuContext}
                        viewOnly={true}
                        dataProp={data}
                        dataKey={`${prefix}refSequestrate.addresses.0`}
                        isLoading={isLoading?.value}
                        locale={locale}
                    ></Address>
                }
            },
            {
                visible: () => true,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24 }, wrapperCol: { xs: 24 } }),
                inputRender: () => {
                    const componentProp = lodash.merge(
                        {
                            menuContext: menuContext,
                            viewOnly: viewOnly,
                            dataProp: data,
                            itemsKey: `${prefix}products`,
                            fetchCriteria: data.products?.fetchCriteria,
                            canCreate: !viewOnly,
                            canDelete: !viewOnly,
                            visiblePagination: false,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { componentKey: "CancelSequestrateProductTable" } })
                    );
                    return () => (
                        <CancelSequestrateProductTable{...componentProp}></CancelSequestrateProductTable>
                    )
                }
            },
            {
                visible: () => true,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24 }, wrapperCol: { xs: 24 } }),
                inputRender: () => {
                    const componentProp = lodash.merge(
                        {
                            menuContext: menuContext,
                            viewOnly: viewOnly,
                            dataProp: data,
                            dataKey,
                            isLoading: isLoading?.value,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { componentKey: "CancelSequestrateResultInfoForm" } })
                    );
                    return () =>
                        <CardBorder title={i18n.global.t('views.request.cancelSequestrateInfo.result')} class="mt-4">
                            <CancelSequestrateResultInfoForm{...componentProp}></CancelSequestrateResultInfoForm>
                        </CardBorder>
                }
            },
        ]
    });
};
